import {customAxiosBE} from "../config";

export async function searchTripInfo(payload) {
    return customAxiosBE.post(`/tripInfo/search?page=${payload.page}&size=${payload.rowsPerPage}&sort=id,desc`, payload)
}

export async function updateTripInfoAPI(payload) {
    return customAxiosBE.put(`/tripInfo`, payload)
}

export async function deleteTripInfoById(id) {
    return customAxiosBE.delete(`/tripInfo/${id}`)
}

export async function getTripInfoById(id) {
    return customAxiosBE.get(`/tripInfo/tripId/${id}`)
}
